const validator = require('validate.js');
const uuid4Type = /^[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i;
const mongoType = /^[a-z0-9A-Z]{16,17}$/i;
const tokenId = /^[a-z0-9A-Z_-]{32,64}$/i;
const alphanum = /^[a-z0-9A-Z\s]$/i;
const ip =
    /((^\s*((([0-9]|[1-9][0-9]|1[0-9]{2}|2[0-4][0-9]|25[0-5])\.){3}([0-9]|[1-9][0-9]|1[0-9]{2}|2[0-4][0-9]|25[0-5]))\s*$)|(^\s*((([0-9a-f]{1,4}:){7}([0-9a-f]{1,4}|:))|(([0-9a-f]{1,4}:){6}(:[0-9a-f]{1,4}|((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3})|:))|(([0-9a-f]{1,4}:){5}(((:[0-9a-f]{1,4}){1,2})|:((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3})|:))|(([0-9a-f]{1,4}:){4}(((:[0-9a-f]{1,4}){1,3})|((:[0-9a-f]{1,4})?:((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:))|(([0-9a-f]{1,4}:){3}(((:[0-9a-f]{1,4}){1,4})|((:[0-9a-f]{1,4}){0,2}:((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:))|(([0-9a-f]{1,4}:){2}(((:[0-9a-f]{1,4}){1,5})|((:[0-9a-f]{1,4}){0,3}:((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:))|(([0-9a-f]{1,4}:){1}(((:[0-9a-f]{1,4}){1,6})|((:[0-9a-f]{1,4}){0,4}:((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:))|(:(((:[0-9a-f]{1,4}){1,7})|((:[0-9a-f]{1,4}){0,5}:((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:)))(%.+)?\s*$))/i;

const MIN_VALID_DATE = Date.UTC(1940, 0, 10);
const COMMON_VALID_DATE = new Date();
const MAX_VALID_DATE = Date.UTC(new Date().getUTCFullYear() + 16, new Date().getUTCMonth() + 1, 20);

/**
 * @return {boolean}
 */
validator.validators.type.types.ID = function (ID) {
    return !!(
        typeof ID === 'object' &&
        typeof ID._id === 'string' &&
        (uuid4Type.test(ID._id) || mongoType.test(ID._id))
    );
};

validator.validators.type.types.stringID = function (ID) {
    return !!(typeof ID === 'string' && (uuid4Type.test(ID) || mongoType.test(ID)));
};

validator.validators.type.types.alphanum = function (value) {
    return !!(typeof value === 'string' && alphanum.test(value));
};

validator.validators.type.types.Ip = function (value) {
    return !!(typeof value === 'string' && ip.test(value));
};

validator.validators.type.types.Token = function (token) {
    return !!(typeof token === 'string' && tokenId.test(token));
};

validator.extend(validator.validators.datetime, {
    // The value is guaranteed not to be null or undefined but otherwise it
    // could be anything.
    parse(value) {
        if (value instanceof Date) {
            return value.getTime();
        } else if (!isNaN(value)) {
            const intValue = parseInt(value);
            if (intValue === 0) {
                // used to bypass earliest validation when field is supposed to be empty
                // grpc protobuff3 will set default value to "0".
                return COMMON_VALID_DATE;
            }

            return new Date(intValue).getTime();
        }

        return;
    },
    // Input is a unix timestamp
    format(value) {
        if (value instanceof Date) {
            return value.toUTCString();
        }

        return new Date(parseInt(value)).toUTCString();
    }
});

validator.validators.isAfter = function (endDate, options, key, attributes) {
    const startDate = attributes[options.startDate];
    const isDependent = attributes[options.condition];
    if (!isDependent) {
        if (parseInt(endDate) > 0 && parseInt(startDate) > 0 && parseInt(endDate) < parseInt(startDate)) {
            return options.errorMessage;
        }
    }

    return;
};

const inOutFormatDecorator = function (func, schema) {
    return (value, config) => {
        if (!func || typeof func !== 'function') {
            throw new Error('No function provided');
        }
        if (!schema || typeof schema !== 'object') {
            throw new Error('No schema provided');
        }
        const error = func(value, schema, config);

        return {
            value,
            error
        };
    };
};

module.exports = {
    validator,
    MIN_VALID_DATE,
    MAX_VALID_DATE,
    inOutFormatDecorator
};
